import React, { useState } from 'react';
import { DropDown } from '../../../../DropDown';
import styles from './searchShips.module.sass';
import { SearchInput } from '../../../../SearchInput';
import { CheckboxList } from '../../../../DropDown/components/CheckboxList';
import {
  YaAndGaSearchLine,
  YaAndGaShipPage,
} from '../../../../../lib/YaAndGaHelper';

export const citiesToString = arr => {
  if (!arr.length) return '';
  const str = arr.join(', ');
  const limit = 30;

  if (str.length > limit) {
    return `${str.slice(0, limit)}...`;
  }

  return str;
};

export const SearchShips = ({
  value: val,
  id,
  placeholder,
  label,
  error,
  ships = [],
  actions,
  isBodyRight,
  disabled,
  view,
  firstLoading,
  onClickField,
  onClearButtonClick,
  searchLabel,
  ...props
}) => {
  const [search, setSearch] = useState('');

  const filterCities = (arr = [], str) =>
    arr.filter(i => i.toLowerCase().includes(str.toLowerCase()));

  return (
    <DropDown
      firstLoading={firstLoading}
      value={citiesToString(val)}
      id={id}
      placeholder={placeholder}
      label={label}
      error={error}
      isBodyRight={isBodyRight}
      view={view}
      onClickField={() => {
        onClickField?.();

        const eventMap = {
          selectedShips: () => YaAndGaShipPage('click_ship_search_line'),
          departure: () =>
            YaAndGaSearchLine('click_field_search_city_departure'),
          arrival: () => YaAndGaSearchLine('click_field_search_city_arrival'),
        };

        // console.log('zalupa', id);

        eventMap[id]?.();
      }}
      onClearButtonClick={onClearButtonClick}
      content={
        <div>
          {actions && <div className={styles.searchCityActions}>{actions}</div>}
          <SearchInput
            placeholder={searchLabel}
            onChange={e => setSearch(e.target.value)}
          />
          <CheckboxList
            items={filterCities(ships, search)}
            name={id}
            view={view}
            disabled={disabled}
          />
        </div>
      }
      {...props}
    />
  );
};

SearchShips.defaultProps = {
  error: undefined,
  actions: null,
  ships: [],
};
